module.exports = __webpack_public_path__ + "static/media/art1.782490e0.png";